import { StarIcon } from '@heroicons/react/solid';
import Image from 'next/legacy/image';
import { StaticImageData } from 'next/image';

type Props = {
  supTitle?: string | React.ReactNode;
  title?: string | React.ReactNode;
  subTitle?: string | React.ReactNode;
  dark?: boolean;
  image?: StaticImageData;
  reviewCount?: boolean;
};

export default function SimpleCenteredHeaderSection({
  supTitle,
  title,
  subTitle,
  dark,
  image,
  reviewCount,
}: Props) {
  return (
    <div className={`relative ${dark ? 'bg-gray-800' : 'bg-white'}`}>
      {image && (
        <div className="absolute inset-0 opacity-30">
          <Image
            src={image}
            alt={'EnergyPal'}
            className="object-cover w-full h-full"
            layout="fill"
            quality={100}
            priority
          />
        </div>
      )}
      <div className="relative px-4 py-16 mx-auto max-w-7xl sm:py-24 sm:px-6 lg:px-8">
        <div className="text-center">
          {supTitle && (
            <p
              className={`text-base font-semibold tracking-wide uppercase ${
                dark ? 'text-accent-400' : 'text-primary'
              }`}
            >
              {supTitle}
            </p>
          )}
          {/* {title && (<p className={`mt-1 text-4xl font-extrabold text-gray-900 sm:text-5xl sm:tracking-tight lg:text-6xl`}>
            {title}
          </p>)}
          {subTitle && (<p className={`mx-auto mt-5 text-xl text-gray-500`}>
            {subTitle}
          </p>)} */}
          {title && (
            <h1
              className={`text-4xl font-bold ${
                dark ? 'text-white' : 'text-gray-900'
              } sm:text-5xl sm:tracking-tight lg:text-5xl`}
            >
              {title}
            </h1>
          )}
          {subTitle && (
            <h2
              className={`mt-5 text-xl ${
                dark ? 'text-gray-100' : 'text-gray-500'
              }`}
            >
              {subTitle}
            </h2>
          )}
          {reviewCount && (
            <div className="flex items-center justify-center pt-5">
              <h2
                className={` mr-1 text-xl ${
                  dark ? 'text-gray-100' : 'text-gray-500'
                }`}
              >
                4.9
              </h2>
              {[0, 1, 2, 3, 4].map((count) => (
                <StarIcon
                  key={count}
                  className="text-yellow-400 h-5 w-5 flex-shrink-0 "
                  aria-hidden="true"
                />
              ))}
              <h2
                className={` text-xl ml-1 ${
                  dark ? 'text-gray-100' : 'text-gray-500'
                }`}
              >
                1000+ Google Reviews
              </h2>
            </div>
          )}
        </div>
      </div>
    </div>
  );
}
